<template>
  <v-container fluid white>
    <div class="licitacao-esclarecimento">
      <div class="text-info-vazio container-box">
        <img src="img/icons/box_archive.svg" alt="Vazio" />
        <p class="text-info">Este processo <b>não possui</b> nenhum esclarecimento <br/> ou impugnação
          <b>solicitados</b> até o momento</p>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'CredenciamentoEsclarecimentoImpugnacaoVazio',
}
</script>

<style scoped lang="stylus">
.text-info
  color #777 !important
  font-size 18px
  text-align center

.text-info-vazio
  display flex
  flex-direction row
  justify-content center
  align-items center

.container-box
  margin-top 20px
  width 100%
  height 300px
  border 1px solid #CCCCCC
  border-radius 5px
  display flex
  flex-direction column

.licitacao-esclarecimento
  min-height 59vh
</style>
